/**
 * @generated SignedSource<<eddaca8e25a1d2310cf3b96f1235eff8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbPricingGuidance_viewer" | "PdpRespSidebarBlurbShipping_viewer">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_viewer";
};
export type PdpRespSidebarBlurbs_viewer$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_viewer"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbPricingGuidance_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d72d1a6f8fab7b62549e758b2f4966c1";

export default node;
